import { $httpCampaign } from '@/plugins/axios'
import AppService from '@/services/app.service'

const AnswerService = {
    getAnswerReportExcel (messageSource, channel, isLike, fromDate, toDate) {
        let query = AppService.buildQuery({
            channel: channel,
            start_date: fromDate,
            end_date: toDate,
            message_source: messageSource,
            is_like: isLike
        })
        return $httpCampaign.get(`/rate-answer-report-excel/${query}`, { responseType: 'blob' }).then(
            data => {
                let fileURL = window.URL.createObjectURL(new Blob([data.data]))
                let fileLink = document.createElement('a')
                fileLink.href = fileURL
                fileLink.setAttribute('download', 'Answer-Report.xlsx')
                document.body.appendChild(fileLink)
                fileLink.click()
            }
        )
    },
    getAnswerReportPieChart (messageSource, channel, fromDate, toDate) {
        let query = AppService.buildQuery({
            channel: channel,
            start_date: fromDate,
            end_date: toDate,
            message_source: messageSource
        })
        return $httpCampaign.get(`/rate-answer-report-pie-chart/${query}`)
    },
    getAgentAnswerReportBarChart (channel, fromDate, toDate) {
        let query = AppService.buildQuery({
            channel: channel,
            start_date: fromDate,
            end_date: toDate,
            message_source: 'agent'
        })
        return $httpCampaign.get(`/rate-answer-report-bar-chart/${query}`)
    },
    getBotAnswerReportBarChart (channel, fromDate, toDate) {
        let query = AppService.buildQuery({
            channel: channel,
            start_date: fromDate,
            end_date: toDate,
            message_source: 'bot'
        })
        return $httpCampaign.get(`/rate-answer-report-bar-chart/${query}`)
    },
    getAnswerReport (messageSource, channel, isLike, fromDate, toDate, pagination) {
        let query = AppService.buildQuery({
            channel: channel,
            start_date: fromDate,
            end_date: toDate,
            message_source: messageSource,
            is_like: isLike
        }) + '&' + AppService.mapPagination(pagination)
        return $httpCampaign.get(`/rate-answer/${query}`)
    }
}
export default AnswerService
